module.exports = __webpack_public_path__ + "static/media/simulation-logic.109a28d1.svg";